import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPipes = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M40 24H36V28H24V22H28V18H24V8C24 6.93913 23.5786 5.92172 22.8284 5.17157C22.0783 4.42143 21.0609 4 20 4H4V0H0V16H4V12H16V18H12V22H16V32C16 33.0609 16.4214 34.0783 17.1716 34.8284C17.9217 35.5786 18.9391 36 20 36H36V40H40",
		fill: "currentColor"
	})
});
export default SvgIconPipes;
